import React, { useContext } from 'react';
import { array, bool, func, string, oneOf } from 'prop-types';
import classNames from 'classnames/bind';

import AutosuggestPart from 'components/AutosuggestPart';
import AutosaggestPopin from 'components/AutosaggestPopin';
import Hint from 'components/Hint';

import { StaticTextContext } from 'context/StaticTextContext';
import { SearchContext } from 'context/SearchContext';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './FieldSearchPart.module.scss';
import SearchIcon from 'media/icons/search.icon.svg';
import CheckIcon from 'media/icons/checkmark.icon.svg';

const cx = classNames.bind(styles);

const FieldSearchPart = ({
  isSelectedPart,
  setPartValue,
  partValue,
  partData,
  pageType,
}) => {
  const { labels } = useContext(StaticTextContext);
  const {
    isPartTooltip,
    isErrorPart,
    isSelectedCar,
    setIsErrorPart,
    setIsPartTooltip,
  } = useContext(SearchContext);

  return (
    <AutosaggestPopin
      tooltipStatus={isPartTooltip}
      toggleTooltip={setIsPartTooltip}
      inputLabel={labels.searchPartLabel}
      className={cx({
        'opened-tooltip': isPartTooltip,
      })}
    >
      <label className={cx('label')} htmlFor="search-part">
        {labels.searchPartLabel}
      </label>
      <div
        className={cx('form-control-wrap', {
          'is-filled': isSelectedPart,
        })}
      >
        <AutosuggestPart
          className={cx('form-control', {
            'is-error': !isSelectedPart && isSelectedCar && isErrorPart,
          })}
          type="text"
          id="search-part"
          pageType={pageType}
          disabled={!isSelectedCar && !partData.length}
          isSelectedCar={isSelectedCar}
          setIsErrorPart={setIsErrorPart}
          partValue={partValue}
          partData={partData}
          updatePartValue={setPartValue}
          placeholder={labels.searchPartPlaceholder}
        />
        <div className={cx('icon-check')}>
          <CheckIcon />
        </div>
        <div
          className={cx('error-message', {
            'is-error': !isSelectedPart && isSelectedCar && isErrorPart,
          })}
        >
          {labels.errorPartField}
        </div>
        {pageType === 'home' && isSelectedCar && (
          <Hint className={cx('hint', 'is-selected')}>
            <span className={cx('hint-text')}>{labels.tipPartInput}</span>
          </Hint>
        )}
        <button
          className={cx('btn', 'ta-btn-primary', 'mobile-button')}
          type="submit"
          disabled={!(isSelectedCar && isSelectedPart)}
        >
          <span className={cx('btn-icon')}>
            <SearchIcon />
          </span>
        </button>
      </div>
    </AutosaggestPopin>
  );
};

FieldSearchPart.propTypes = {
  partValue: string.isRequired,
  partData: array,
  pageType: oneOf(['home', 'search']).isRequired,
  isSelectedPart: bool.isRequired,
  setPartValue: func.isRequired,
};

FieldSearchPart.defaultProps = {
  partData: [],
};

export default withErrorBoundary(FieldSearchPart);



// WEBPACK FOOTER //
// ./src/components/SearchByVin/components/FieldSearchPart/FieldSearchPart.js